export const printConstants = {
    CREATE_PRINT_LIST: 'CREATE_PRINT_LIST',
    DELETE_PRINT_LIST: 'DELETE_PRINT_LIST',

    UPDATE_BULK_IMAGES_PRINT_REQUEST: 'UPDATE_BULK_IMAGES_PRINT_REQUEST',
    UPDATE_BULK_IMAGES_PRINT_SUCCESS: 'UPDATE_BULK_IMAGES_PRINT_SUCCESS',
    UPDATE_BULK_IMAGES_PRINT_FAILURE: 'UPDATE_BULK_IMAGES_PRINT_FAILURE',

    SUCCESSFULLY_PRINT: 'SUCCESSFULLY_PRINT' 
}


// WEBPACK FOOTER //
// ./src/constants/print.js